import { render, staticRenderFns } from "./MarDashboard.vue?vue&type=template&id=38c56cf0&"
import script from "./MarDashboard.vue?vue&type=script&lang=js&"
export * from "./MarDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports